module.exports = __webpack_public_path__ + "static/media/6-4.804fa7d3.mp3";